import moment from "moment";

export const numberInputOnWheelPreventChange = (e: any) => {
  // Prevent the input value change
  e.target.blur();

  // Prevent the page/container scrolling
  e.stopPropagation();

  // Refocus immediately, on the next tick (after the current
  // function is done
  setTimeout(() => {
    e.target.focus();
  }, 0);
};

export function getErroFnc(errors: any, setState: React.Dispatch<React.SetStateAction<boolean>>) {
  const errorFind = errors.find((item: any) => item.errors.length > 0);
  errorFind ? setState(true) : setState(false);
}

export function findStore(storeList: Store[], storeId: string) {
  const chosenStore = storeList.find(store => store.id === storeId);

  if (chosenStore) {
    return chosenStore;
  } else {
    return null;
  }
}
export const formatDateTime = (dateString: string): string => {
  const date: Date = new Date(dateString);
  return moment(date).format("DD-MM-YYYY, HH:mm");
};

export const formatIndexTable = (idx: number, perPage: number, currentPage: number) => {
  return idx + 1 + perPage * (currentPage - 1);
};
